export const getApiUrl = () => process.env.REACT_APP_API_URL;

export const getApiEndpoint = (path: string): string => getApiUrl() + path;
